import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchTruckClassesQuery } from '@/features/truck-classes'
import { fetchTruckClassesList } from '@/features/truck-classes/api'

import { TruckClassesSearchSchema } from './-models/truck-classes-search-schema'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/'
)({
  validateSearch: (search) => parse(TruckClassesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchTruckClassesQuery(tenantKey, deps)

    const truckClasses = await fetchTruckClassesList(
      query,
      abortController.signal
    )
    return {
      authUser: auth.user,
      truckClasses: truckClasses.data,
      pagination: truckClasses.pagination
    }
  }
})
